import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

function Sidebar2({ permissions, logout }) {
    const [selected, setSelected] = useState('');
    const sidebarRef = useRef(null);
    const location = useLocation();

    // Detect the current route and keep it in selected



    useEffect(() => {
        setSelected(location.pathname);
    }, [location]);

    const hasAccess = (objId) => {
        return permissions.some(obj => obj.obj_ID === objId);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (window.innerWidth <= 768) {
                if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                    const htmlElement = document.querySelector('html');
                    const body = document.querySelector('body');
                    htmlElement.setAttribute('data-sidebar-size', 'sm');
                    body.setAttribute('class', 'twocolumn-panel');
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarRef]);

    return (
        <div
            className="app-menu navbar-menu"
            style={{ background: "#000" }}
            ref={sidebarRef}
        >

            <div className="navbar-brand-box" style={{ padding: "10px", background: "#000" }}>
                <Link to="/main-panel" className="logo logo-light">
                    <span className="logo-sm">
                        <img src="assets/images/dbclondon-sm.jpg" alt="" height="40" />
                    </span>
                    <span className="logo-lg align-items-center mt-4">
                        <img
                            src="assets/images/dbclondon-sm.png"
                            alt="Logo"
                            style={{ width: "168px", height: "150px" }}
                        />
                        <br />
                    </span>
                </Link>
            </div>


            <div
                id="scrollbar"
                data-id="scrollbar"
                style={{
                    height: "calc(100% - 200px)",
                    overflowY: "auto",
                    paddingBottom: "20px"
                }}
            >
                <div className='container-fluid'>
                    <ul className="navbar-nav" id="sidebar-accordion">
                        <li className="menu-title">
                            <span data-key="t-menu">Admin Panel</span>
                        </li>

                        <li>
                            <Link
                                className={`nav-link menu-link ${selected.startsWith('/main-panel') ? 'active-menu' : ''}`}
                                to="/main-panel"
                            >
                                <i className="ri-home-2-line"></i><span>Main</span>
                            </Link>
                        </li>

                        {/* Pre Production */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/quotation') || selected.startsWith('/orders') || selected.startsWith('/bussiness-library') || selected.startsWith('/mould') || selected.startsWith('/jobs-print-folder') || selected.startsWith('/print-history') || selected.startsWith('/wax-folder') ? 'active-menu' : ''}`}
                                href="#SALES"
                                data-bs-toggle="collapse"
                            >
                                <i className="ri-file-list-3-line"></i><span>Pre Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="SALES" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/quotation" className={`nav-link submenu-link ${selected.startsWith('/quotation') ? 'active-submenu' : ''}`}>Instant Quotes</Link></li>
                                    <li><Link to="/orders" className={`nav-link submenu-link ${selected.startsWith('/orders') ? 'active-submenu' : ''}`}>Orders</Link></li>
                                    <li><Link to="/bussiness-library" className={`nav-link submenu-link ${selected.startsWith('/bussiness-library') ? 'active-submenu' : ''}`}>STL Adjustment Folder</Link></li>
                                    <li><Link to="/mould-folders" className={`nav-link submenu-link ${selected.startsWith('/mould-folders') ? 'active-submenu' : ''}`}>Mould Library</Link></li>
                                    <li><Link to="/mould-auth" className={`nav-link submenu-link ${selected.startsWith('/mould-auth') ? 'active-submenu' : ''}`}>Customer Mould Manager</Link></li>
                                    <li><Link to="/jobs-print-folder" className={`nav-link submenu-link ${selected.startsWith('/jobs-print-folder') ? 'active-submenu' : ''}`}>Print Folder</Link></li>
                                    <li><Link to="/print-history" className={`nav-link submenu-link ${selected.startsWith('/print-history') ? 'active-submenu' : ''}`}>Print History</Link></li>
                                    <li><Link to="/wax-folder" className={`nav-link submenu-link ${selected.startsWith('/wax-folder') ? 'active-submenu' : ''}`}>Wax Folder</Link></li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/job-live-feed') || selected.startsWith('/scan-point') || selected.startsWith('/jobs-reprint-folder') || selected.startsWith('/collective-jobs') ? 'active-menu' : ''}`}
                                href="#Jobs"
                                data-bs-toggle="collapse"
                            >
                                <i className="ri-folder-settings-fill"></i><span>Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Jobs" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/job-live-feed" className={`nav-link submenu-link ${selected.startsWith('/job-live-feed') ? 'active-submenu' : ''}`}>Live Feed</Link></li>
                                    <li><Link to="/scan-point" className={`nav-link submenu-link ${selected.startsWith('/scan-point') ? 'active-submenu' : ''}`}>Scan Point</Link></li>
                                    <li><Link to="/jobs-reprint-folder" className={`nav-link submenu-link ${selected.startsWith('/jobs-reprint-folder') ? 'active-submenu' : ''}`}>Reprint Folder</Link></li>
                                    <li><Link to="/collective-jobs" className={`nav-link submenu-link ${selected.startsWith('/collective-jobs') ? 'active-submenu' : ''}`}>Collective Jobs</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Post Production */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/invoice-list') ? 'active-menu' : ''}`}
                                href="#Jobs1"
                                data-bs-toggle="collapse"
                            >
                                <i className="ri-list-check-2"></i><span>Post Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Jobs1" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/invoice-list" className={`nav-link submenu-link ${selected.startsWith('/invoice-list') ? 'active-submenu' : ''}`}>Invoices</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Customers */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/customers') ? 'active-menu' : ''}`}
                                href="#Customers"
                                data-bs-toggle="collapse"
                            >
                                <i className="ri-group-line"></i><span>Customers</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Customers" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/customers" className={`nav-link submenu-link ${selected.startsWith('/customers') ? 'active-submenu' : ''}`}>Customers</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Administration */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/quotations-history') || selected.startsWith('/order-history') || selected.startsWith('/wax-history') || selected.startsWith('/collective-groups') || selected.startsWith('/branches') || selected.startsWith('/product-list') || selected.startsWith('/materials') || selected.startsWith('/metal-types') || selected.startsWith('/option-job-category') || selected.startsWith('/option-job-value') ? 'active-menu' : ''}`}
                                href="#Administration"
                                data-bs-toggle="collapse"
                            >
                                <i className="las la-pencil-ruler"></i><span>Administration</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Administration" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/quotations-history" className={`nav-link submenu-link ${selected.startsWith('/quotations-history') ? 'active-submenu' : ''}`}>Quotation History</Link></li>
                                    <li><Link to="/order-history" className={`nav-link submenu-link ${selected.startsWith('/order-history') ? 'active-submenu' : ''}`}>Order History</Link></li>
                                    <li><Link to="/wax-history" className={`nav-link submenu-link ${selected.startsWith('/wax-history') ? 'active-submenu' : ''}`}>Wax History</Link></li>
                                    <li><Link to="/collective-groups" className={`nav-link submenu-link ${selected.startsWith('/collective-groups') ? 'active-submenu' : ''}`}>Collective Groups</Link></li>
                                    <li><Link to="/branches" className={`nav-link submenu-link ${selected.startsWith('/branches') ? 'active-submenu' : ''}`}>Branches</Link></li>
                                    <li><Link to="/product-list" className={`nav-link submenu-link ${selected.startsWith('/product-list') ? 'active-submenu' : ''}`}>Products</Link></li>
                                    <li><Link to="/materials" className={`nav-link submenu-link ${selected.startsWith('/materials') ? 'active-submenu' : ''}`}>Materials</Link></li>
                                    <li><Link to="/metal-types" className={`nav-link submenu-link ${selected.startsWith('/metal-types') ? 'active-submenu' : ''}`}>Material Types</Link></li>
                                    <li><Link to="/job-category-options" className={`nav-link submenu-link ${selected.startsWith('/option-job-category') ? 'active-submenu' : ''}`}>Job Category Options</Link></li>
                                    <li><Link to="/option-job-value" className={`nav-link submenu-link ${selected.startsWith('/option-job-value') ? 'active-submenu' : ''}`}>Job Value Options</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Metrics */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/casting-charges') || selected.startsWith('/daily-metal-fix') || selected.startsWith('/api-metal-price') || selected.startsWith('/wax-to-metal-conversion') ? 'active-menu' : ''}`}
                                href="#Metrics"
                                data-bs-toggle="collapse"
                            >
                                <i className="las la-tachometer-alt"></i><span>Metrics</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Metrics" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/casting-charges" className={`nav-link submenu-link ${selected.startsWith('/casting-charges') ? 'active-submenu' : ''}`}>Casting Charges</Link></li>
                                    <li><Link to="/daily-metal-fix" className={`nav-link submenu-link ${selected.startsWith('/daily-metal-fix') ? 'active-submenu' : ''}`}>Daily Metal Price Fix</Link></li>
                                    <li><Link to="/api-metal-price" className={`nav-link submenu-link ${selected.startsWith('/api-metal-price') ? 'active-submenu' : ''}`}>Metal Price API</Link></li>
                                    <li><Link to="/wax-to-metal-conversion" className={`nav-link submenu-link ${selected.startsWith('/wax-to-metal-conversion') ? 'active-submenu' : ''}`}>Wax to Metal Conversion</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Settings */}
                        <li>
                            <a
                                className={`nav-link menu-link ${selected.startsWith('/company') || selected.startsWith('/users') || selected.startsWith('/groups') || selected.startsWith('/change-password') || selected.startsWith('/metals-price-api') || selected.startsWith('/xero-autenticator') || selected.startsWith('/profiles') || selected.startsWith('/docs') ? 'active-menu' : ''}`}
                                href="#Settings"
                                data-bs-toggle="collapse"
                            >
                                <i className="ri-settings-2-line"></i><span>Settings</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Settings" data-bs-parent="#sidebar-accordion">
                                <ul className="nav nav-sm flex-column">
                                    <li><Link to="/company/list" className={`nav-link submenu-link ${selected.startsWith('/company') ? 'active-submenu' : ''}`}>Company</Link></li>
                                    <li><Link to="/users/list" className={`nav-link submenu-link ${selected.startsWith('/users') ? 'active-submenu' : ''}`}>Users</Link></li>
                                    <li><Link to="/groups" className={`nav-link submenu-link ${selected.startsWith('/groups') ? 'active-submenu' : ''}`}>Groups</Link></li>
                                    <li><Link to="/change-password" className={`nav-link submenu-link ${selected.startsWith('/change-password') ? 'active-submenu' : ''}`}>Change Password</Link></li>
                                    <li><Link to="/metals-price-api" className={`nav-link submenu-link ${selected.startsWith('/metals-price-api') ? 'active-submenu' : ''}`}>Process - Metal Price API</Link></li>
                                    <li><Link to="/xero-authenticator" className={`nav-link submenu-link ${selected.startsWith('/xero-authenticator') ? 'active-submenu' : ''}`}>Xero Authenticator</Link></li>
                                    <li><Link to="/profiles" className={`nav-link submenu-link ${selected.startsWith('/profiles') ? 'active-submenu' : ''}`}>Profile</Link></li>
                                    <li><Link to="/docs/pages-starter.html" className={`nav-link submenu-link ${selected.startsWith('/docs') ? 'active-submenu' : ''}`} target="_blank">Documentation</Link></li>
                                </ul>
                            </div>
                        </li>

                        {/* Logout */}
                        <li>
                            <Link
                                className="nav-link"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Are you sure you want to logout?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonText: "Yes, logout"
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            logout();
                                        }
                                    });
                                }}
                                style={{ color: 'white' }}
                            >
                                <i className="mdi mdi-logout fs-34 align-middle me-1" style={{ color: "red" }}></i>
                                <span>Logout</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    );
}

export default Sidebar2;
